module.exports = __webpack_public_path__ + "static/images/shopify-logo.QrRy2zx.png";